import announcements from "@/frame/messages/mixins/announcements.js";

export default {
  // eslint-disable-next-line
  data() {
    return {};
  },
  mixins: [announcements],
  methods: {
    verifyUserAccessStatusLock(tag, did, list) {
      let logic = true;
      // look for item and pull it out
      for (let i = 0; i < list.length; i++) {
        if (tag === "C1") {
          if (list[i].select.cdid === did) {
            if (list[i].trans.stat.lock === true) {
              logic = true;
            } else {
              logic = false;
            }
          }
        }
      }
      // update store
      return logic;
    },
    changeListItemLockStatusRetrunItem(logic, did, list) {
      // console.log("RUN LIST");
      // console.log(logic);
      // console.log(did);
      let temp = null;
      // look for item and pull it out
      for (let i = 0; i < list.length; i++) {
        if (list[i].basic.did === did) {
          temp = list[i];
          temp.basic.lock = logic;
        }
      }
      // update store
      return temp;
    },
    findTagThenReturnIndex(tag, list) {
      let index = null;
      // look for item and pull it out
      for (let i = 0; i < list.length; i++) {
        if (tag === list[i].tag) {
          index = i;
          break;
        }
      }
      // update store
      return index;
    },
    findTypeInCharThenReturnItem(type, list) {
      let item = null;
      // look for item and pull it out
      for (let i = 0; i < list.length; i++) {
        if (type === list[i].char.type) {
          item = list[i];
          break;
        }
      }
      // update store
      return item;
    },
    findTypeInCharThenReturnLimVal(type, list) {
      let limval = null;
      // look for item and pull it out
      for (let i = 0; i < list.length; i++) {
        if (type === list[i].char.type) {
          limval = list[i].char.limval;
          break;
        }
      }
      // update store
      return limval;
    },
    findTagRelationshipThenReturnIndex(tagr, list) {
      let index = null;
      // look for item and pull it out
      for (let i = 0; i < list.length; i++) {
        if (tagr === list[i].tagr) {
          index = i;
          break;
        }
      }
      // update store
      return index;
    },
    appendItem(item, list) {
      let temp = list;
      // let obj = Object.assign({}, item);
      // eslint-disable-next-line
      let obj = (JSON.parse(JSON.stringify(item)));
      // const months = ['Jan', 'March', 'April', 'June'];
      temp.splice(list.length, 0, obj);
      // temp.push(obj);
      return temp;
    },
    appendItemLimited(item, list, limit) {
      let temp = list;
      // console.log("APPEND LIST limit");
      // console.log(list.length);
      // console.log(limit);
      // if length has no limit then no issue
      if (list.length < limit) {
        temp.push(item);
      } else {
        let msg = "Register is at limit. Item not added.";
        this.generateInfoSnackbar(this.ui.colorBlue1, msg);
      }
      return temp;
    },
    appendItemLimitedwithDuplicateCheck(item, list, limit, word) {
      let tempList = list;
      let newList = [];
      let duplicate = false;
      // console.log("APPEND LIST with DUPLICATE AND LIMIT");
      // console.log(list);
      // console.log(item);
      // if length has no limit then no issue
      if (list.length < limit && list.length > 0) {
        for (var i = 0; i < tempList.length; i++) {
          newList.push(tempList[i]);
          if (tempList[i].did === item.did) {
            duplicate = true;
          }
        }
        // END OF LOOP
        if (duplicate === false) {
          newList.push(item);
          let msg = word + " " + item.title + " was added.";
          this.generateInfoSnackbar("warning", msg);
          // console.log(msg);
        } else {
          let msg = "Duplicate " + word + " was found.";
          this.showSnackbar(msg, "error");
          // console.log(msg);
        }
        // FOR LOOP FINSIHED
        // console.log(duplicate);
      } else if (list.length < limit && list.length === 0) {
        newList.push(item);
        // let msg = word + " " + item.title + " was added.";
        // this.generateInfoSnackbar("warning", msg);
      } else {
        this.showSnackbar("Register is at limit. Item not added.", "error");
        // temp.shift();
        // temp.push(item);
      }
      return newList;
    },
    deleteAssetReturnTree(item, list) {
      let newList = [];
      for (let i = 0; i < list.length; i++) {
        if (item.did !== list[i].did) {
          newList.push(list[i]);
        }
      }
      return newList;
    },
    appendItemToRegister(item, list) {
      let tempList = list;
      let newList = [];
      // if length has no limit then no issue
      if (tempList.length > 0) {
        for (var i = 0; i < tempList.length; i++) {
          newList.push(tempList[i]);
        }
      }
      // ADD New item
      newList.push(item);
      // HELP
      // console.log("APPEND");
      // console.log(item);
      // console.log(newList);
      return newList;
    },
    appendItemLimitedTop(item, list, limit) {
      let temp = list;
      // console.log("APPEND LIST limit");
      // console.log(list.length);
      // console.log(limit);
      // if length has no limit then no issue
      if (list.length < limit) {
        temp.unshift(item);
      } else {
        temp.pop();
        temp.unshift(item);
        // eslint-disable-next-line
        this.showSnackbar("Register is at limit. Last item was removed.", "warning");
        // temp.shift();
        // temp.push(item);
      }
      return temp;
    },
    changeItemReturnList(item, list) {
      let newList = [];
      for (let i = 0; i < list.length; i++) {
        if (item.basic.idi === list[i].basic.idi) {
          newList.push(item);
        } else {
          newList.push(list[i]);
        }
      }
      return newList;
    },
    changeItemReturnListCheckDID(item, list) {
      let newList = [];
      for (let i = 0; i < list.length; i++) {
        if (item.basic.did === list[i].basic.did) {
          newList.push(item);
        } else {
          newList.push(list[i]);
        }
      }
      return newList;
    },
    addItemReturnListCheckDID(item, list) {
      let newList = [];
      for (let i = 0; i < list.length; i++) {
        newList.push(list[i]);
      }
      // ADD NEW
      newList.unshift(item);
      return newList;
    },
    removeItemReturnListCheckDID(item, list) {
      let newList = [];
      let did = item.basic.did;
      for (let i = 0; i < list.length; i++) {
        if (did !== list[i].basic.did) {
          newList.push(list[i]);
        }
      }
      return newList;
    },
    // eslint-disable-next-line
    sortListbyIDGORG(list) {
      let ref = 0;
      let idg = 0;
      let newList = [];
      for (let i = 0; i < list.length; i++) {
        idg = list[i].basic.idg;
        if (idg > ref) {
          ref = idg;
          newList.unshift(list[i]);
        } else {
          newList.push(list[i]);
        }
      }
      // ADD NEW
      return newList;
    },
    sortListbyIDG(list) {
      let temp = list;
      // eslint-disable-next-line
      let sort = temp.sort((r1, r2) => (r1.basic.idg > r2.basic.idg) ? 1 : (r1.basic.idg < r2.basic.idg) ? -1 : 0);
      return sort;
    },
    sortListDateCrtAsc(list) {
      let temp = [];
      let idgmax = 0;
      if (list !== null) {
        for (var i = 0; i < list.length; i++) {
          let idg = list[i].basic.idg;
          if (idg > idgmax) {
            idgmax = idg;
            temp.unshift(list[i]);
          } else {
            temp.push(list[i]);
          }
        }
      }
      return temp;
    },
    sortListDateCrtDes(list) {
      let temp = [];
      let idgmax = 0;
      if (list !== null) {
        for (var i = 0; i < list.length; i++) {
          let idg = list[i].basic.idg;
          if (idg > idgmax) {
            idgmax = idg;
            temp.push(list[i]);
          } else {
            temp.unshift(list[i]);
          }
        }
      }
      return temp;
    },
    deleteItemReturnList(item, list) {
      let newList = [];
      for (let i = 0; i < list.length; i++) {
        if (item.basic.idi !== list[i].basic.idi) {
          newList.push(list[i]);
        }
      }
      return newList;
    },
    removeItem(item, list) {
      let temp = [];
      // look for item and pull it out
      for (let i = 0; i < list.length; i++) {
        if (item !== list[i]) {
          temp.push(item);
        }
      }
      // update store
      return temp;
    },
    removeItemObj(obj, list) {
      let temp = [];
      // look for item and pull it out
      for (let i = 0; i < list.length; i++) {
        if (obj.title !== list[i].title) {
          let newObj = {
            title: list[i].title
          };
          temp.push(newObj);
        }
      }
      // update store
      return temp;
    },
    removeItemFromImportList(item, list) {
      let temp = [];
      // look for item and pull it out
      for (let i = 0; i < list.length; i++) {
        if (item.did !== list[i].did) {
          temp.push(item);
        }
      }
      // update store
      return temp;
    },
    checkForItemObjDuplicate(obj, list) {
      // u = did
      let duplicate = null;
      if (list === null) {
        duplicate = false;
      } else if (list.length !== 0) {
        for (var i = 0; i < list.length; i++) {
          if (obj.title === list[i].title) {
            duplicate = true;
            break;
          } else {
            duplicate = false;
          }
        }
      } else {
        duplicate = false;
      }
      return duplicate;
    },
    deleteItemFromImportList(idi, oldList) {
      let newList = [];
      // loop
      for (var i = 0; i < oldList.length; i++) {
        // eslint-disable-next-line
        if (idi !== oldList[i].idi) {
          newList.push(oldList[i]);
        }
      }
      return newList;
    },
    findIdiMax(list) {
      // console.log("");
      // console.log("FIND LIST IDI MAX");
      // console.log(list);
      let maxIdi = 0;
      if (list.length === 0) {
        maxIdi = 1;
      } else {
        for (var i = 0; i < list.length; i++) {
          if (maxIdi < list[i].idi) {
            maxIdi = list[i].idi;
          }
        }
      }
      return maxIdi;
    },
    generateIDI(list) {
      // console.log("");
      // console.log("Generate IDI");
      // console.log(list);
      let idi = 0;
      if (list.length === 0) {
        idi = 1;
      } else {
        for (var i = 0; i < list.length; i++) {
          if (idi < list[i].basic.idi) {
            idi = list[i].basic.idi;
          }
        }
        // Increment List
        idi = idi + 1;
      }
      return idi;
    },
    checkUserAccessDuplicate(did, list) {
      // console.log("CHECK ACCESS DUPLICATE");
      // console.log(did);
      // console.log(list.length);
      // console.log(list);
      // let list = this.getUserAccessList;
      // console.log(parsedobj);
      // u = did
      let duplicate = true;
      if (list === null) {
        duplicate = false;
      } else if (list.length === 0) {
        duplicate = false;
      } else if (list !== null) {
        for (let i = 0; i < list.length; i++) {
          // console.log(list[i].char.itemDid);
          if (did === list[i].char.did) {
            duplicate = true;
            break;
          } else {
            duplicate = false;
          }
        }
      } else {
        duplicate = true;
      }
      return duplicate;
    },
    checkForItemDuplicate(item, list) {
      // u = did
      let duplicate = true;
      if (list === null) {
        duplicate = false;
      } else if (list.length !== 0) {
        for (var i = 0; i < list.length; i++) {
          if (item === list[i]) {
            duplicate = true;
            break;
          } else {
            duplicate = false;
          }
        }
      } else {
        duplicate = true;
      }
      return duplicate;
    },
    checkForDuplicateDocument(did, list) {
      // u = did
      let duplicate = null;
      if (list === null) {
        duplicate = false;
      } else if (list.length !== 0) {
        for (var i = 0; i < list.length; i++) {
          if (did === list[i].basic.did) {
            duplicate = true;
            break;
          } else {
            duplicate = false;
          }
        }
      } else {
        duplicate = false;
      }
      return duplicate;
    },
    checkForDuplicateItem(did, list) {
      // u = did
      let duplicate = null;
      if (list === null) {
        duplicate = false;
      } else if (list.length !== 0) {
        for (var i = 0; i < list.length; i++) {
          if (did === list[i].did) {
            duplicate = true;
            break;
          } else {
            duplicate = false;
          }
        }
      } else {
        duplicate = false;
      }
      return duplicate;
    },
    renderArrayofObjects(list) {
      let obj = null;
      let newList = [];
      this.results.push(obj);
      for (var i = 0; i < list.length; i++) {
        obj = Object.assign({}, list[i]);
        newList.push(obj);
      }
      return newList;
    },
    checkForDuplicateItemInList(item, list) {
      // console.log("DUPLICATE CHECK");
      // console.log(item);
      // console.log(list);
      let duplicate = null;
      if (list === null) {
        duplicate = false;
      } else if (list.length === 0) {
        duplicate = false;
      } else if (list.length > 0) {
        for (var i = 0; i < list.length; i++) {
          if (item.did === list[i].did) {
            duplicate = true;
            break;
          } else {
            duplicate = false;
          }
        }
      } else {
        duplicate = false;
      }
      return duplicate;
    },
    disableItemFromList(u) {
      this.dialog = false;
      let newlist = this.preList;
      // look for item and pull it out
      if (this.preList.length !== 0) {
        for (var i = 0; i < this.preList.length; i++) {
          if (this.preList[i].id === u.id) {
            newlist[i].act = false;
          }
        }
        // update store
        this.updateStoreList(newlist);
      }
    }
  }
};
